import React from 'react';

import { useSnackbar } from 'notistack';

import { hasIntersection } from '@looko-corp/acloset-react-kit';

import { AclosetCodeError } from '@/app/utils/AclosetCodeError';
import { roleViewer } from '@/router/consts';
import { useUserAuth } from '@/state/cookieContext';

import axiosInstance from '../axios';

/**
 * ROLE_VIEWER일 경우 막는 메서드 리스트
 */
const BLOCKED_METHODS = ['put', 'patch', 'delete', 'post'];

/**
 * ROLE_VIEWER일 경우 허용하는 URL 리스트
 */
const ACCEPT_URL_LIST = ['/shops/users/sign-in', '/shops/labeling/confirm'];
const CORNER_LOGIS_PROXY_URL = '/corner-logis/proxy';
/**
 * ROLE_VIEWER도 허용하는 URL 목록 (부분 일치, 동적 경로 대응)
 * - 원스톱 솔루션 비용납부 확인 페이지의 입금일/정산내역 수정
 */
const CORNER_LOGIS_SETTLEMENTS_BULK_PATCH_URL = '/corner-logis-settlements/bulk-patch';

/**
 * user role이 ROLE_VIEWER 일 경우,
 * POST, PUT, DELETE, PATCH 메서드 막음
 * (로그인 url 제외하고 막음)
 */
export const useNotAllowedMethodEffect = () => {
  const { enqueueSnackbar } = useSnackbar();

  const userAuth = useUserAuth();

  React.useEffect(() => {
    const id = axiosInstance.interceptors.request.use(async config => {
      if (userAuth?.roles.includes(roleViewer)) {
        if (
          BLOCKED_METHODS.includes(config.method ?? '') &&
          !hasIntersection(ACCEPT_URL_LIST, [config.url]) &&
          !config.url?.includes(CORNER_LOGIS_PROXY_URL) &&
          !config.url?.includes(CORNER_LOGIS_SETTLEMENTS_BULK_PATCH_URL)
        ) {
          console.warn(`Current user role: ${userAuth.roles[0]}`);
          console.error(`The ${config.method?.toUpperCase()} method is not allowed.`);

          enqueueSnackbar(`현재 권한(${roleViewer})으로는 불가능한 처리입니다.`, { variant: 'error' });

          return Promise.reject(
            new AclosetCodeError(`The ${config.method?.toUpperCase()} method is not allowed.`, 'NOT_ALLOWED_METHOD'),
          );
        }
      }

      return config;
    });

    return () => {
      axiosInstance.interceptors.request.eject(id);
    };
  }, [enqueueSnackbar, userAuth?.roles]);
};
